import photo1 from './project19-1.png';
import photo2 from './project19-2.png';
import photo3 from './project19-3.png';
import photo4 from './project19-4.png';

const project19 = {
  id: 19,
  name: '쉐어릿(shareeat/it)',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '이승진 이가은',
    },
    {
      position: 'BackEnd Developer',
      names: '정유진 이여진',
    },
  ],
  about:
    '잉여식량 나눔을 실천하고자 하는 사람들과 나눔을 필요로하는 사람들을 연결하여 지역사회 네트워크를 형성하고, ‘잉여식량 나눔서비스를 통한 환경 보호’ 라는 목표를 달성하는 잉여식량 매칭 플랫폼입니다.',
  links: {
    website: 'https://shareeatit.netlify.app/',
    github: 'https://github.com/ShareEatIt',
  },
  photos: [photo1, photo2, photo3, photo4],
};

export default project19;
